export enum OtherMedicaidEnum {
    NotAMedicaid = "N",
    MedicaidPending = "+"
}
